const en = {
  COMMON: {
    NEXT: 'Next ',
    NEXT_PLURAL: 'Next ',
    TOMORROW: 'tomorrow',
    DONT_KNOW: 'I don\'t know',
    TODAY: 'today',
    DAY: 'day',
    DAYS: 'days',
    HOUR: 'hour',
    HOUR_SHORT: 'h',
    HOURS_2_4: 'hours',
    HOURS: 'hours',
    MINUTE: 'minute',
    MINUTES_2_4: 'minutes',
    MINUTES: 'minutes',
    BOOK_REVIEW: 'Book review',
    ARTICLE: 'Article',
    PODCAST: 'Podcast',
    WORKSHOPS: 'Workshops',
    WEBINAR: 'Webinar',
    CONFERENCE: 'Conference',
    LECTURE: 'Lecture',
    SEARCH: {
      CLOSE: 'Close',
      TIP: 'To open the search engine, press ctrl + s on the keyboard. To close, press esc.',
      LABEL: 'Search',
      PLACEHOLDER: 'Enter the topic you are interested in...',
      NO_RESULTS: 'No results found for the phrase: @1',
      LOADING: 'Searching...',
    },
  },
  COOKIES: {
    TITLE: 'Cookies monster was here already!',
    MESSAGE: 'My website uses "cookies". Detailed informations about it you can find in my %%cookies policy%%.',
    ACCEPT: 'Accept',
    NOT_ACCEPT: 'I\'m not okay with that',
  },
  NOT_TRANSLATED: {
    TITLE: 'This page is available only in polish',
    MESSAGE: 'I am working on the translation!',
  },
  HEADER: {
    TITLE: 'Mateusz Jabłoński - Blog, programming, selfdevelopment',
  },
  FOOTER: {
    TITLE: 'Mateusz Jabłoński - Blog, programming, selfdevelopment',
    FUNDS_INFO: {
      MESSAGE: 'I forward %%5% of payments%% on ',
      INFO: ' and from the sales of my courses to the Foundation ',
      ENCOURAGEMENT: 'Join me and support this cause!',
      LOGO_ALT: 'Logo of Radość z Uśmiechu Foundation',
      HELP_ACTION_LABEL: 'Support the foundation',
    },
    SOCIAL_MEDIA: {
      TITLE: 'Check out my %%social media!%%',
    },
  },
  MENU: {
    HOME: 'Home',
    BLOG: 'Blog',
    ABOUT: 'About',
    WORKSHOPS: 'Workshops',
    PODCAST: 'Podcast',
    CONTACT: 'Contact',
    MEMBER_AREA: 'Student zone',
    PRIVACY_POLICY: 'Privacy policy',
    COOKIES: 'About cookies',
    DOCS: 'Documents',
  },
  HOME: {
    HERO: {
      FREE_CONTENT_ACTION: 'View free content',
      ABOUT_ACTION: 'About project',
    },
    LAST_ARTICLES: 'Last %%articles%%',
    LAST_ARTICLES_END: {
      TITLE: 'And these are just the latest articles!',
      MESSAGE: 'You can find a larger dose of knowledge on the blog page. You\'re cordially invited!',
      ACTION: 'See all',
    },
    ALL_ARTICLES: 'All my articles',
    LAST_PODCASTS: 'Last %%podcasts%%',
    ALL_PODCASTS: 'All podcasts',
    WANT_TO_BE_A_GUEST: 'Want be a guest of podcast',
    RECOMMENDED_BOOKS: 'Recommended %%books%%',
    MORE_BOOKS: 'More books',
    LAST_WORKSHOPS: 'Currently available ',
    LAST_WORKSHOPS_STRONG: 'workshops',
    NEXT_PODCAST: 'podcast',
    NEXT_ARTICLE: 'article',
    NEXT_ARTICLE_SLIDE: 'Next article',
    PREV_ARTICLE_SLIDE: 'Previous article',
    LISTEN_PODCAST: 'Listen to my podcast:',
    LISTEN_PODCAST_ON: 'Listen $1 podcast on $2',
    LAST_EVENTS: 'Next %%events%%',
    NEXT_EVENT: 'event',
    NEXT_EVENT_IN: 'In just @1 @2',
    NEXT_EVENT_TODAY: 'Today',
    BOOKS: {
      NO_LINK: 'No review',
      WITH_LINK: 'Go to review',
    },
    NEWSLETTER: {
      TITLE: 'Join the newsletter and stay up to date %%for free!%%',
      DESCRIPTION: 'Join my newsletter for free. You will receive information about new articles, programming world curiosities, and many practical tips on personal development.',
    },
  },
  NEWSLETTER: {
    EMAIL_REQUIRED: 'Email field is required',
    EMAIL_PLACEHOLDER: 'Enter your email address',
    ACTION: 'Join the Newsletter',
    WELCOME_EMAIL: {
      SUBJECT: 'Welcome aboard!',
      TITLE: 'Hi!',
      PARAGRAPH_1: 'I’m really glad you’ve joined my newsletter.',
      PARAGRAPH_2: 'Once a month, I’ll send a concise, high-value dose of insights from the areas I work with every day - no fluff and no marketing noise.',
      PARAGRAPH_3: 'Practical thoughts on architecture, Node.js and TypeScript in production, frontend nuances, and occasionally - finance, productivity, and building independence as a specialist.',
      PARAGRAPH_4: 'My goal is for every email to give you one concrete takeaway: a new perspective, a tool, a pattern, or an insight you can immediately apply in your work.',
      SIGNATURE: 'Talk soon, Mateusz',
    },
    ERROR: 'The provided email is invalid or has already been registered in our database.',
    SUCCESS: 'Success! Your email address has been successfully registered.',
  },
  BREADCRUMBS: {
    CONTACT: 'Contact',
    ABOUT: 'About',
    WORKSHOPS: 'Workshops',
    BOOKS: 'Books',
    DOCS: 'Documents',
  },
  ABOUT: {
    MOTIVATOR: {
      TITLE: 'I would like to be %%very good%% at what I do',
      MESSAGE: 'my experience shows me how much I have been able to achieve, and also how much is still in front of me.',
    },
    DOTTED_TITLE: 'Space %%between characters%%',
    LAST_CONTENT: {
      TITLE: 'Latest content',
      TEXT: 'Below you will find the latest materials I have prepared. I invite you to take a look at them. I hope you will draw a lot of value for yourself from them.',
    },
    WHAT_CAN_I_TEACH_YOU: {
      TITLE: 'What can I teach you?',
      I_TEACH_ADULTS_KIDS_SUBTITLE: 'I teach programming to children and adults',
      I_TEACH_ADULTS_KIDS_TEXT: 'Teaching programming to adults takes place through programming schools such as Kodilla or privately in the form of %%mentoring or training and workshops%% (for Sages, StacjaIT, Orb Experts, or Noble Prog). Mentoring is a specific form of cooperation that requires full commitment from each party.',
      TOPICS_SUBTITLE: 'On the classes with me, you will cover topics related to:',
      TOPICS: {
        0: 'widely understood programming',
        1: 'good practices and quality',
        2: 'testing',
        3: 'frontend technologies',
        4: 'tools and programmer\'s workshop',
      },
      WORK_WITH_KIDS_TEXT: 'Work with children is primarily based on showing a %%new way of learning%%, getting to know technology, pointing out opportunities and dangers associated with the IT industry. In programming classes, children independently create simple programs using the most popular programming languages. %%The youngest children I work with are 11 years old.%% Classes take place in small groups of up to 4 people or individually.',
      TRAININGS_TEXT: 'On trainings and workshops with me, you can count on lots of smiles, understanding, reliable knowledge, interesting additional materials, and engaging tasks.',
    },
    CURRENT: {
      READ: {
        TITLE: 'I am currently reading',
        NO_ACTIVITY: 'Temporary inactivity',
      },
      LISTEN: {
        TITLE: 'Recently listened',
        NO_ACTIVITY: 'Temporary inactivity',
      },
    },
    STORY: {
      TITLE: 'How did it all start?',
      INTRO: 'I became interested in programming a long time ago. At the age of just 12, together with two of my friends, we dreamed about big IT projects, took part in various computer science competitions, and had a lot of fun doing it.',
      BLOCKQUOTE: 'I never imagined that programming would become both my passion and profession.',
      EPISODE_1_1: 'In 2011, life steered my career toward web development.',
      EPISODE_1_2: 'From the very beginning, I felt that this was my place, that it brought me a lot of joy, and that the results I achieved kept pushing me forward—something made me want to dive deeper and get more out of it.',
      EPISODE_1_3: 'Undoubtedly, my first mentors and colleagues played a significant role in my journey.',
      EPISODE_2_1: 'A few years later, I decided to try my hand at education. I began my mentoring path at the end of 2016.',
      EPISODE_2_2: 'Since then, I have constantly worked on developing not only my technical skills, but also my soft skills—speaking, writing, communicating.',
      EPISODE_2_3: 'I realized how important the role of a mentor or trainer is during every mentoring session, workshop, or training. One can be a great programmer and still lack the inclination to teach others.',
      PHOTO_1_CAPTION: 'That’s me with friends in front of Secondary School No. 2. Year 2008.',
      PHOTO_2_CAPTION: 'First steps with WordPress and Magento. Year 2011.',
      PHOTO_3_CAPTION: 'Internal training at Sonalake. Year 2020.',
    },
  },
  ARTICLE: {
    SUMMARY: {
      TITLE: 'From this article you will learn:',
    },
    META: {
      PUBLICATION_DATE: 'Publication date',
      LEVEL: 'Level',
      PODCAST: 'Podcast',
      EPISODE: 'Episode',
      CATEGORY: 'Category',
      READING_DATE: 'Reading date',
      MY_RATE: 'My rating',
    },
    BUY_COFFEE: {
      TITLE: 'Do you like my work?',
      MESSAGE: 'All materials on the site are free. If you find the materials useful, please consider supporting me by buying me a coffee. ;)',
      ACTION: 'I\'ll put the coffee!',
    },
    ACTIONS: {
      READ_MORE: 'Read more',
    },
    SOURCES: 'Sources',
    SHARE: 'Share this article:',
    UPDATE_NOTE: {
      TITLE: 'Updated on @1',
    },
    AUTHOR: {
      TITLE: 'About the author',
      YOU_WILL_FIND_ME: 'You\'ll find me'
    },
    COMMENTS: {
      TITLE: 'Comments',
      ADD: 'Add comment',
      NO_NAME: 'Anonymous author',
      FIRST_MESSAGE: 'No one has posted anything yet, but that means.... you may be the first.',
      COMMENTING_TITLE: 'You comment on the article',
      BACK: 'Go back'
    },
    RELATED: {
      TITLE: 'You may be interested in',
      TEXT: 'If this article interested you, check out other materials related to it thematically. Below you will find articles and podcast episodes authored by me, as well as books I recommend that expand on this topic.',
    },
  },
  ARTILES: {
    LOAD_MORE: 'Load more content'
  },
  WORKSHOPS: {
    ACTIONS: {
      TAKE_PART: 'Take part',
      ALL: 'All workshops',
    },
    PROGRAM: {
      TITLE: 'Training program',
    },
    REVIEWS: {
      TITLE: 'Join the group of satisfied participants of my workshops!',
      NO_REVIEWS: 'Currently no reviews for these workshops.',
      ANONYMOUS_USER: 'Workshop participant',
    },
    CREATING_APP_WITH_REACT: {
      TITLE: 'Creating an application using React',
      DESCRIPTION: 'Get to know one of the most popular libraries on the market. During three days of workshops, you will learn the best practices for creating applications using React.',
      LONG_DESCRIPTION: 'During the workshops, participants will not only learn the key concepts of React but will primarily learn how to build applications in accordance with the best market practices. Throughout the workshop, we will go through the entire process - from requirements analysis, through component architecture design, to functionality implementation and state management. Special emphasis will be placed on code organization, reusability, and performance optimization. After completing the training, participants will be ready to independently create complex user interfaces and make informed design decisions in new and existing React projects.',
    },
    WORDPRESS_BASICS: {
      TITLE: 'Wordpress - from installation to management',
      DESCRIPTION: 'The goal of the workshops is to show the possibilities of creating simple websites without writing code using the Wordpress content management system. The skills gained during the workshops will allow you to build websites for both private and professional purposes.',
      LONG_DESCRIPTION: 'The workshops are aimed at people who want to quickly and effectively learn how to create websites without writing code. Participants will learn the logic of how WordPress works, how to configure themes and plugins, manage content, and maintain the site\'s currency and security. We work on practical examples so that everyone can build their own site from scratch. This approach gives participants the skills needed to create simple sites for themselves as well as to develop sites for clients, companies, or organizations in a professional and easy-to-maintain way.',
    },
    ADVANCED_NODEJS_WITH_TYPESCRIPT: {
      TITLE: 'Advanced Node.js with TypeScript',
      DESCRIPTION: 'Get to know advanced techniques for creating backend applications using Node.js and TypeScript. During two days of workshops, you will learn how to build scalable and efficient web services.',
      LONG_DESCRIPTION: 'The training is intended for people who want to take their backend work with Node.js to the next level. Participants will learn advanced techniques used in professional teams, including multi-layer application architecture, integration of TypeScript in large projects, design patterns, and approaches to scaling services. We work on real examples related to data processing, handling asynchronicity, worker threads, streams, and database integration. As a result, after the training, participants will be able to create modern, efficient, and well-designed backend services that perform well in production environments.',
    },
    ELECTRONJS_DESKTOP_APPS: {
      TITLE: 'Building desktop applications with ElectronJS',
      DESCRIPTION: 'Learn the basics of creating desktop applications using Electron. During a one-day workshop, you will learn how to organize a project, integrate it with Node.js, create a user interface, and prepare a finished application for distribution.',
      LONG_DESCRIPTION: 'The workshop introduces participants to the world of creating desktop applications using web technologies. During a day of intensive work, participants will learn the architecture of ElectronJS, how to effectively combine Node.js logic with an interface created in HTML, CSS, and JavaScript, and develop their own application ready for compilation for various operating systems. The workshop focuses on practice: from basic IPC mechanisms, through window management, to security and distribution. The participant finishes the training with the ability to independently create and develop internal desktop tools, prototypes, and commercial applications.',
    },
    ADVANCED_TYPESCRIPT: {
      TITLE: 'Advanced Programming in TypeScript',
      DESCRIPTION: 'Get to know the key elements of the TypeScript language and learn how to design safe, typed code. During a one-day workshop, we will discuss the type system, working with interfaces and classes, designing generics, and best practices used in modern JavaScript applications.',
      LONG_DESCRIPTION: 'During the training, participants will delve into the advanced mechanisms of the TypeScript type system. We will discuss practical scenarios related to designing interfaces, modeling complex types, building generic components, and creating error-resistant APIs. A strong emphasis will be placed on real examples from large projects, so that participants can consciously use typing to improve code quality and predictability. After the workshop, participants will have the skills to design code that is scalable, easy to maintain, and supports teams working on complex front-end and back-end applications.',
    },
    ADVANCED_JAVASCRIPT: {
      TITLE: 'Advanced Programming in Javascript',
      DESCRIPTION: 'Get to know the modern approach to programming in JavaScript. During a one-day workshop, we will discuss the latest language features, safe and efficient code patterns, working with asynchronicity, and practical functional programming techniques.',
      LONG_DESCRIPTION: 'The workshop focuses on modern JavaScript standards and techniques that allow writing efficient, readable, and balanced code. Participants will analyze advanced aspects of working with functions, classes, modules, and asynchronicity, as well as learn patterns and anti-patterns used in everyday programming work. During practical exercises, we will discuss code optimization techniques, debugging difficult cases, and ways to build modular architecture. After the training, participants will be able to consciously use the full potential of modern JavaScript in projects of various scales.',
    },
    REACT_REDUX: {
      TITLE: 'Reactive web application programming based on React and Redux',
      DESCRIPTION: 'Get to know the solid basics of state management in React applications using Redux. During a one-day workshop, we will discuss the unidirectional data flow architecture, creating reducers and actions, working with middleware, and optimization techniques for large projects based on Redux.',
      LONG_DESCRIPTION: 'The workshop provides a detailed introduction to state management in React applications using Redux. Participants will learn how to build scalable action, reducer, and store structures, work with middleware, developer tools, and optimization techniques. We will analyze data flow in the unidirectional data flow architecture and demonstrate how to use it to control complex business processes. After the workshop, participants will be able to design and develop large applications where state management is clear, predictable, and easy to maintain — both individually and in larger teams.',
    },
    TYPESCRIPT_PLAYWRIGHT: {
      TITLE: 'Automation of functional testing of web applications using Playwright and TypeScript',
      DESCRIPTION: 'Get to know the practical basics of end-to-end test automation using Playwright. During a one-day workshop, we will discuss environment configuration, writing tests, working with locators and interactions, as well as more advanced features such as POM, API mocking, and report generation.',
      LONG_DESCRIPTION: 'During the workshop, participants will gain practical skills in automating E2E tests with Playwright and TypeScript. Together, we will build a test environment from scratch, write sets of stable tests, and discuss techniques for working with locators, API mocking, test isolation, and environment control. Special emphasis will be placed on creating tests that follow design patterns and building a POM architecture that scales with the project. After the training, participants will be able to prepare a complete test automation process, integrate it with CI/CD, and effectively detect regressions in web applications of various scales.',
    },
    VUE_ASTRO: {
      TITLE: 'Astro & Vue: Architecture, Hydration and Pragmatic Frontend Design',
      DESCRIPTION: 'During this workshop, participants will learn advanced techniques for creating modern web applications using the Astro and Vue frameworks. We will discuss application architecture, hydration strategies, and best practices for user interface design.',
      LONG_DESCRIPTION: 'Learn advanced techniques for building web applications with Astro and Vue. The workshop covers application architecture, hydration strategies, and a practical approach to user interface design. Participants will learn how to integrate Vue components in the Astro environment, optimize application performance, and apply best practices for creating responsive and scalable interfaces. After the workshop, participants will be able to independently build modern web applications leveraging the full potential of both frameworks.',
    },
    GITHUB_COPILOT: {
      TITLE: 'GitHub Copilot in Developer Workflows',
      DESCRIPTION: 'Learn practical ways to use GitHub Copilot in everyday software development. During the workshop, we will cover effective prompting, code generation and refactoring, working with tests, and safe use of AI in a project.',
      LONG_DESCRIPTION: 'The workshop shows how to use GitHub Copilot as real support in a developer workflow, not only as a tool for suggesting single lines of code. Participants will learn how to provide useful context for AI, work with Copilot Chat, speed up analysis of existing code, generate tests, documentation, and refactoring proposals. Strong emphasis will be placed on evaluating generated solutions, checking security, understanding the tool\'s limitations, and applying good practices when introducing Copilot to a team. After the training, participants will be able to use AI consciously in the everyday software development process.',
    },
  },
  WORKSHOP: {
    DURATION: 'Duration',
    COST_PER_USER: 'Cost per person',
    CITY_OR_REMOTE: 'City / remote',
    ASK_FOR_PRICE: 'Ask for a date',
    GROSS: 'gross',
    NET: 'net',
    COST_NOTE: 'for a group of min. 4 people',
    AVERAGE_RATING: 'Participant Rating',
    AVERAGE_RATING_SHORT: '(average rating)',
    BASED_ON_RESPONSES: 'Based on @1 responses',
    EDITIONS: 'Workshops already',
    EDITIONS_STRONG: 'behind us',
    EDITIONS_DESCRIPTION: 'Below you will find a list of workshop editions I have run. Each one means a new group, different challenges, and concrete results.',
    OPEN_EDITION_PLACE: 'OPEN workshops',
    PLANNED_EDITION: 'Training scheduled',
    TOTAL_EDITIONS: 'Total editions',
    UPCOMING_EDITIONS: 'Upcoming dates',
    PAST_EDITIONS: 'Past editions',
    AUDIENCE: {
      TITLE: 'Who this',
      TITLE_STRONG: 'training is for',
      DESCRIPTION: 'This workshop works best for participants who want to turn knowledge into practical project decisions and code written in realistic conditions.',
      FOR_TITLE: 'This training is for you if',
      FOR_ITEMS: [
        'you want to organize your knowledge and see how to apply it in day-to-day work',
        'you work on applications or tools that need to stay readable, maintainable, and testable',
        'you value practical exercises, trade-off discussions, and examples close to real projects',
      ],
      NOT_FOR_TITLE: 'This is not the best choice if',
      NOT_FOR_ITEMS: [
        'you are looking only for a theoretical lecture without workshop practice',
        'you need a very basic introduction to programming from scratch',
        'you expect ready-made recipes without discussing context, constraints, and consequences',
      ],
    },
    TRAINER: {
      EYEBROW: 'Trainer',
      TITLE: 'Mateusz',
      NAME: 'Jabłoński',
      DESCRIPTION: 'Senior Frontend Developer, trainer, and author of technical materials. Since 2016, I have been running training sessions on JavaScript, TypeScript, React, testing, and tools that support software developers.',
      EXPERIENCE_VALUE: '14+',
      EXPERIENCE_LABEL: 'years of experience',
      TEACHING_SINCE_VALUE: '2016',
      TEACHING_SINCE_LABEL: 'teaching since',
      RATING_LABEL: 'based on @1 responses',
      RATING_LABEL_WITHOUT_RESPONSES: 'average trainer rating',
      ACTION: 'Get to know me',
    },
  },
  CONTACT: {
    FORM: {
      TITLE: 'Contact Form',
      DESCRIPTION: 'For your convenience, the form is shortened to the smallest number of points so that I can contact you as quickly and efficiently as possible.',
      WANT_MORE: 'Do you want to send more information?',
      WANT_MORE_TEXT: 'I respond fastest to messages sent using the above form. The waiting time for a response to a regular email may be slightly longer. But I promise - it won’t be too long. :)',
      WANT_MORE_ACTION: 'Write to me',
    },
    NEWSLETTER: {
      TITLE: 'My newsletter',
      MAIN_CONTENT_1: 'Join my newsletter for free. Every two weeks, you will receive a message from me with information about new materials that you will find on my website. You will not only be the first, but you will also gain access to curiosities, interesting offers, and previously unpublished materials.',
      MAIN_CONTENT_2: 'The newsletter, like most of the materials on my site, is completely free. I promise not to spam and to send what you will actually find useful.',
    },
  },
  POLL: {
    TITLE: 'Questionnaire',
    DESCRIPTION: 'The following survey concerns the “@1” training. The survey is anonymous. It consists of 5 steps. Every answer is extremely valuable to me, as it helps me improve the quality of the training. Thank you for your time!',
    LOADING: 'Loading questionnaire',
    PASSWORD_QUESTION: 'Enter access password for the survey',
    PASSWORD: 'Enter access password',
    PASSWORD_VERIFICATION: 'Verifying access password',
    NEXT: 'Next',
    BACK: 'Back',
    SUBMIT: 'Submit',
    STEP: 'Step @1 of @2',
    THANKS: {
      TEXT_1: 'Thank you for your time and honest answers. As a token of appreciation, I would like to give you a code for a 20% discount on your first hosting space purchase at mydevil.net.',
      TEXT_2: 'Enter the referral code below when creating an account at mydevil.net and enjoy a cheaper hosting service.',
    },
    SELECT_YOUR_ANSWER: 'Select your rating',
    WRITE_YOUR_COMMENT: 'Write your opinion',
    WRONG_EMAIL: 'The provided email is not valid',
    SUCCESS_MESSAGE: 'Your answers have been saved.',
    CLOSED: 'This questionnaire has been closed. You can no longer submit responses.',
    ERRORS: {
      SELECT_RATING: 'Select your rating.',
      WRITE_OPINION: 'Write your opinion.',
      INVALID_EMAIL: 'The provided email is not valid.',
    },
    ANSWERS: {
      GOOD_OR_BAD: {
        ONE: 'Terrible',
        TWO: 'Bad',
        THREE: 'So-so',
        FOUR: 'Good',
        FIVE: 'Very good',
      },
      KNOWLEDGE_NOTES: {
        ONE: 'No knowledge',
        TWO: 'Little knowledge',
        THREE: 'Some knowledge',
        FOUR: 'Good understanding',
        FIVE: 'Professional',
      },
    },
    AVERAGE_NOTES: {
      WOW: 'Wow! I am very glad that you appreciate my work! I would be grateful if in the fourth step you write what you liked the most and what I could still improve. 😉',
      IAM_SORRY: 'I am sorry that I did not meet your expectations. I would be grateful if in the fourth step you describe the elements that need improvement. Every training is a new experience. Every opinion is a chance for development. 😉',
    },
    QUESTIONS: {
      TRAINER_PREPARATION: {
        TITLE: 'How do you rate the trainer\'s preparation?',
        DESCRIPTION: 'On a scale from 1 to 5, where 1 is terrible and 5 is very good.',
        INTERNAL_QUESTIONS: {
          TRAINER_KNOWLEDGE: 'He had knowledge in the field of the topics discussed',
          TRAINER_EXPERIENCE: 'He had experience in the field of the topics discussed',
          TRAINER_COMMUNICATION: 'He conveyed information systematically and effectively',
          TRAINER_ENGAGEMENT: 'He was communicative and engaged',
          TRAINER_QUESTIONS: 'He tried not to leave any questions unanswered',
          TRAINER_OPENNESS: 'He was open to the needs of the group',
          TRAINER_CULTURE: 'He was characterized by high personal culture',
        }
      },
      WORKSHOPS: {
        TITLE: 'How do you rate the training?',
        DESCRIPTION: 'On a scale from 1 to 5, where 1 is terrible and 5 is very good.',
        INTERNAL_QUESTIONS: {
          WORKSHOPS_CONTENT: 'The topics in the training program were properly selected',
          WORKSHOPS_REALIZATION: 'The training program was implemented to an appropriate extent',
          WORKSHOPS_DURATION: 'The duration was matched to the content of the program',
        }
      },
      YOUR_KNOWLEDGE: {
        TITLE: 'How do you rate your knowledge level?',
        DESCRIPTION: 'On a scale from 1 to 5, where 1 is no knowledge and 5 is a professional.',
        INTERNAL_QUESTIONS: {
          YOUR_KNOWLEDGE_BEFORE: 'How do you rate your knowledge level BEFORE the training?',
          YOUR_KNOWLEDGE_AFTER: 'How do you rate your knowledge level AFTER the training?',
          YOUR_KNOWLEDGE_USEFULNESS: 'How do you rate the usefulness of the knowledge provided during the training?',
        }
      },
      YOUR_OPINION: {
        TITLE: 'What would you like to convey to the trainer?',
        DESCRIPTION: 'I appreciate any feedback. It helps me improve my work in the future, introduce new things, and fix mistakes.',
        INTERNAL_QUESTIONS: {
          YOUR_OPINION_ABOUT_WORKSHOPS: 'What do you think can be improved / enhanced / changed or what should remain unchanged? How did you like the training?',
          YOUR_OPINION_ABOUT_MATERIALS: 'What do you think about the training materials? Presentations, gadgets, certificates, etc.',
        },
      }
    },
    NEWSLETTER_OPTION: {
      TITLE: 'Newsletter',
      DESCRIPTION: 'Do you want to receive information about new trainings and materials? Provide your email address, and it will be added to my mailing list. It optional and you can unsubscribe at any time.',
      YOUR_EMAIL: 'Your email address',
    },
  },
  PODCAST: {
    MY_PODCASTS: {
      TITLE: 'My podcasts',
      META: {
        SEASON: 'Season',
        EPISODES: 'Episodes',
      }
    },
    GUEST_PODCASTS: {
      TITLE: 'Guest podcasts',
    },
    COMMON: {
      LISTEN: 'Listen',
      SOURCES_TITLE_DOUBLE: 'You can find our podcast',
      AUTHOR: 'Author: @1',
      COMMENTS: 'Comments',
      READ_MORE: 'Read more',
      TRANSCRIPTION: 'Transcription',
    },
    PLAYER: {
      LOADING_FILE: 'Audio file loading in progress',
      PLAY_PAUSE: 'Play / Pause',
    },
  },
  DOCS: {
    TITLE: 'Documents',
    DESCRIPTION: 'Below is a table with information about the legal documents available on my website. These documents contain information about how this site operates.',
  },
  LEVELS: {
    0: 'Code Novice',
    1: 'Beginner Scripter',
    2: 'Apprentice Programmer',
    3: 'Compiler Enthusiast',
    4: 'Module Builder',
    5: 'Algorithm Architect',
    6: 'Loop Master',
    7: 'Debugging Shaman',
    8: 'Library Master',
    9: 'Code Judge',
    10: 'Polymorphism Expert',
    11: 'Interface Wizard',
    12: 'Scalability Engineer',
    13: 'Architecture Guru',
    14: 'Programming Grandmaster',
  },
}

export default en;
